export class MonitoredCase {
  id: number | null = null;
  code: string = '';
}
